import React, { useState, useContext, useRef } from 'react';
import { ProcessActionsProps } from '../../../components/process/process-types';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import {
  FormContext,
  useEventCallback,
  useFormSelector,
  SnackbarContext,
  abortableFetch,
  AbortableFetch,
  FormHandle,
} from '@eas/common-web';
import Button from '@material-ui/core/Button';
import { ProductionSite } from '../../../models';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Messages, EvidenceAPI } from '../../../enums';
import { ProcessForm } from '../production-site-split-types';
import { StepOriginalProductionSiteForm } from './step-original-production-site-types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(1),
      float: 'right',
    },
    actionsContainer: {
      marginBottom: theme.spacing(2),
    },
  })
);

function apiCall(id: string) {
  return abortableFetch(`${EvidenceAPI.PRODUCTION_SITES}/${id}`, {
    method: 'GET',
    headers: new Headers({ 'Content-Type': 'application/json' }),
  });
}

export function StepOriginalProductionSiteActions({
  handleNext,
  handleExit,
}: ProcessActionsProps<ProcessForm>) {
  const classes = useStyles();

  const { setFieldValue } = useContext(FormContext);
  const { showSnackbar } = useContext(SnackbarContext);

  const [loading, setLoading] = useState(false);
  const originalProductionSite = useFormSelector(
    ({ originalProductionSite }: StepOriginalProductionSiteForm) =>
      originalProductionSite
  );
  const formRef = useRef<FormHandle>(null);
  const fetch = useRef<AbortableFetch | null>(null);

  const handleNextWithProductionSiteLoad = useEventCallback(async () => {
    formRef.current?.validateForm();

    if (originalProductionSite) {
      try {
        setLoading(true);

        if (fetch.current !== null) {
          fetch.current.abort();
        }

        fetch.current = apiCall(originalProductionSite?.id);

        const productionSiteFullData: ProductionSite = await fetch.current.json();

        setLoading(false);

        setFieldValue('originalProductionSite', productionSiteFullData);
        setFieldValue('newProductionSite', productionSiteFullData);

        handleNext();
      } catch (err) {
        if (err.name !== 'AbortError') {
          showSnackbar(
            ...Messages.ProductionSite.PRODUCTION_SITE_PRELOAD.ERROR
          );

          throw err;
        }
        setLoading(false);

        return undefined;
      }
    } else {
      handleNext();
    }
  });

  return (
    <div className={classes.actionsContainer}>
      <div>
        <Button
          variant="contained"
          color="primary"
          onClick={handleNextWithProductionSiteLoad}
          className={classes.button}
          disableElevation
          disabled={loading}
          startIcon={
            loading && <CircularProgress size="20px" color="inherit" />
          }
        >
          Další
        </Button>
        <Button
          onClick={handleExit}
          className={classes.button}
          disableElevation
        >
          Zrušit
        </Button>
      </div>
    </div>
  );
}
